export const FEATURE_NAMESPACE = 'feature.jobs-to-be-done'
